import { CountryCodes } from 'src/common/enums';

const COMMON_SOCIAL_MEDIA_URLS = {
  linkedin: 'https://linkedin.com/company/glints',
  mail: 'mailto:hi@glints.com',
};

const SG_SOCIAL_MEDIA_URLS = {
  ...COMMON_SOCIAL_MEDIA_URLS,
  facebook: 'https://www.facebook.com/glintssingapore/',
  twitter: 'https://x.com/GlintsSingapore',
};

export const SOCIAL_MEDIA_URL_MAP = {
  [CountryCodes.SG]: SG_SOCIAL_MEDIA_URLS,
  [CountryCodes.ID]: {
    ...COMMON_SOCIAL_MEDIA_URLS,
    facebook: 'https://www.facebook.com/glintsindonesia/',
    instagram: 'https://www.instagram.com/glintsid/',
    twitter: 'https://x.com/glintsid',
    tiktok: 'https://www.tiktok.com/@glintsindonesia',
  },
  [CountryCodes.VN]: {
    ...COMMON_SOCIAL_MEDIA_URLS,
    facebook: 'https://facebook.com/glintsvietnam/',
  },
  [CountryCodes.TW]: SG_SOCIAL_MEDIA_URLS,
};

const getSocialMediaUrl = (countryCode = null) => {
  if (countryCode in SOCIAL_MEDIA_URL_MAP) {
    return SOCIAL_MEDIA_URL_MAP[countryCode];
  }
  return SOCIAL_MEDIA_URL_MAP[CountryCodes.SG];
};

export default getSocialMediaUrl;
